import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconWarningMark = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 50" fill="none" {...props}>
    <path
      d="M24.6748 7.45716C26.6015 4.13528 31.3985 4.13529 33.3252 7.45716L53.645 42.4914C55.5784 45.8247 53.1733 50 49.3199 50H8.68014C4.82672 50 2.42165 45.8247 4.35498 42.4914L24.6748 7.45716Z"
      fill="#FF4B00"
    />
    <path d="M29.1338 22V30.8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M29.1338 37.5996H29.145" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default IconWarningMark;
